import { TranslatePipe } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";

import { ChangeDetectionStrategy, Component, computed, input, output } from "@angular/core";

import { Customer } from "../../../apis/networkdashboard/rest/models/customer";

@Component({
  selector: "customer-display",
  templateUrl: "./customer-display.html",
  styleUrls: ["./customer-display.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AngularSvgIconModule, TranslatePipe],
})
export class CustomerDisplay {
  customer = input.required<Customer>();
  allowSwitch = input(false);
  openSwitchDialog = output<void>();

  protected customerName = computed(() => this.customer().name);
  protected customerAbbreviation = computed(() => this.customer().abbreviation);
}
